import { createSlice } from "@reduxjs/toolkit";

export const gatewayconfigdata = createSlice({
    name: 'gatewayconfigdata',

    initialState: {
        gatewayno:[],

    },

    reducers: {
        updategatewayno: (state, data) => {
            state.gatewayno =[...state.gatewayno,data.payload];
        },
        getgatewayno: (state, data) => { 
            state.gatewayno = data.payload
        },
        deletegatewayno: (state, data,deleteGatewayArr) => { 
            // data.payload.map((val)=>(
            //     state.gatewayno=state.gatewayno.filter((gid)=>gid.id!==val) 
            // ))
            //state.gatewayno = data.payload
        },
        getgatewaystatus: (state, data) => {
            // state.gatewayno = data.payload
            data.payload.map((val,index)=>{
                //state.gatewayno[index].data.enable=val
                state.gatewayno[index].data.connectionState=val
        })
        },
    }
})

export const {updategatewayno, getgatewayno,deletegatewayno,getgatewaystatus} = gatewayconfigdata.actions
export default gatewayconfigdata.reducer